import { render, staticRenderFns } from "./ReOrderOption_Ap.vue?vue&type=template&id=21f5517a&scoped=true"
import script from "./ReOrderOption_Ap.vue?vue&type=script&lang=js"
export * from "./ReOrderOption_Ap.vue?vue&type=script&lang=js"
import style0 from "./ReOrderOption_Ap.vue?vue&type=style&index=0&id=21f5517a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5517a",
  null
  
)

export default component.exports